<template>
  <v-layout row justify-center>
    <v-dialog v-model="showNewHealthCard" max-width="90%"
      transition="dialog-bottom-transition" @keydown.esc="showNewHealthCard = false">
      <v-card>
        <v-toolbar color="blue-grey lighten-5">
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">Avaliação inicial</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="showNewHealthCard = false">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <health-card-item :healthCard="{}"></health-card-item>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import EventBus from '@/event-bus'
import UserHealthCardItem from '@/components/user/evaluations/UserHealthCardItem'

export default {
  props: ['healthCard'],
  data: () => ({
    showNewHealthCard: false,
    loadingRequest: false
  }),

  methods: {

  },

  beforeDestroy () {
    EventBus.$off('showNewHealthCard')
  },

  mounted () {
    EventBus.$on('showNewHealthCard', data => {
      this.showNewHealthCard = data
    })
  },

  components: {
    'health-card-item': UserHealthCardItem
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/evaluations/UserNewHealthCard.vue